<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"></app-header>

    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper" [style.backgroundImage]="getBackgroundImageUrl(baniInfo?.TileImageURL)">
          <h1 class="bani-title mb-0">{{ baniInfo?.BaniName }}</h1>
        </div>
      </div>
      <div class="breadcrumbs-options-wrapper breadcrumbs-tools-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="breadcrumbs-wrapper" *ngIf="introductionParamLabel">
          <span (click)="goToBani()" class="cursor-pointer">
            {{ baniInfo?.BaniName }} &nbsp;
          </span>
          > &nbsp; {{ introductionParamLabel }}
          <span>
            <mat-icon class="open-breadcrumb-links-icon"
              [matMenuTriggerFor]="breadCrumbsIntroductionMenu">arrow_drop_down</mat-icon>
  
            <mat-menu class="introduction-selectables" #breadCrumbsIntroductionMenu="matMenu">
              <button *ngIf="baniInfo?.Introduction" (click)="goToIntroduction()" class="introduction-selectable-button"
                mat-menu-item>
                {{ "introduction" | translate }}
              </button>
              <button *ngIf="baniInfo?.HistoricalDimension" (click)="goToHistoricalDimension()"
                class="introduction-selectable-button" mat-menu-item>
                {{ "historical" | translate }}
              </button>
              <button *ngIf="baniInfo?.CulturalDimension" (click)="goToCulturalDimension()"
                class="introduction-selectable-button" mat-menu-item>
                {{ "Cultural_Dimension" | translate }}
              </button>
              <button *ngIf="baniInfo?.MusicalDimension" (click)="goToMusicalDimension()"
                class="introduction-selectable-button" mat-menu-item>
                {{ "musical" | translate }}
              </button>
  
              <button *ngIf="baniInfo?.SignificantTerms" (click)="goToSignificantTerms()"
                class="introduction-selectable-button" mat-menu-item>
                {{ "Significant_Terms" | translate }}
              </button>
              <div *ngIf="allNavigationButtonsList?.length">
                <!-- <div *ngFor="let sec of allNavigationButtonsList[0].Sections; let i = index"> -->
                <div *ngFor="let sec of allNavigationSectionButtonsListSorted; let i = index">
                  <button class="menu-btn" (click)="navigateOnDetailPage(sec.SectionName)">{{sec.SectionName}}</button>
                </div>
              </div>
            </mat-menu>
          </span>
          
          &nbsp;
        </div>
        <div class="formatting-options-wrapper">
          <span> {{ "Text_Size" | translate }} </span>
          <!-- <mat-icon (click)="showFontList()"> format_size</mat-icon>
 -->
          <div class="font-wrapper">
            <mat-icon class="fnt-icon" [matMenuTriggerFor]="fontMenu"><img alt="Font Menu Resize Icon"
                src="/assets/images/font.png"> </mat-icon>
            <mat-menu class="fnt-menu" xPosition="before" #fontMenu="matMenu">
              <ul id="fontSize" class="fnt-menu-list" [class.is-mobile]="isHandsetPortrait">
                <li (click)="setFont(16)" style="font-size: 16px">16</li>
                <li (click)="setFont(18)" style="font-size: 18px">18</li>
                <li (click)="setFont(20)" style="font-size: 20px">20</li>
                <li (click)="setFont(22)" style="font-size: 22px">22</li>
                <li (click)="setFont(24)" style="font-size: 24px">24</li>
              </ul>
            </mat-menu>
            <span class="seprator">|</span>
          </div>
          <span> {{ "Share" | translate }} </span>
          <div class="social-share" [class.is-mobile]="isHandsetPortrait">
            <mat-icon class="share-icon" [matMenuTriggerFor]="shareMenu"><img class="v-align-b" alt="Social Share Icon"
                src="/assets/images/share.png"> </mat-icon>
            <mat-menu class="share-menu" xPosition="before" #shareMenu="matMenu">
              <share-buttons theme="circles-dark" [include]="['copy', 'facebook','twitter', 'whatsapp']"
                [showIcon]="true" [showText]="false" url="{{shareUrl}}" twitterAccount="rodrigokamada" class="pt-5">
              </share-buttons>
            </mat-menu>
          </div>

          <!-- <mat-icon>bookmark_border</mat-icon> -->
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="introduction-wrapper" [style.fontSize.px]="fontSize">
          <!-- <div class="introduction-footer">
            <div class="footer-nav-buttons-wrapper" [style.justify-content]="previous ? 'space-between' : 'end'">
              <button
                *ngIf="previous"
                [ngClass]="!previous  ? 'disabled' : '' "
                class="btn-sggs"
                (click)="handlePrevious()"
              >
              &lt; {{ "previous" | translate }}  -->
          <!-- <img alt="Previous Button Image"  [ngClass]="!previous  ? 'disabled' : '' " src="/assets/images/prev.png">
                <img alt="Previous Button Image" [ngClass]="!previous  ? '' : 'disabled' "src="/assets/images/prev-g.png"> -->
          <!-- </button> -->

          <!-- [disabled]="!next" -->
          <!-- <button
                
                class="btn-sggs"
                color="primary"
                (click)="handleNext()"
              >
              {{ "next" | translate }} &gt; -->
          <!-- <img alt="Next Button Image" [src]="fetchLanguage() === 'pa' ? '/assets/images/next-golden-pa.png' : '/assets/images/next-1.png'" [attr.width]="fetchLanguage() != 'pa' ? 'auto' : '70'"> -->
          <!-- </button>
            </div>
          </div> -->

          <!-- ============================================================================================================================================================ -->
          <!-- <div class="introduction-footer">
            <div class="footer-nav-buttons-wrapper align-items-center justify-content-between">
              <button [ngClass]="!previous  ? 'invisible' : 'visible' " class="btn-sggs" (click)="handlePrevious()">
                &lt; {{ "previous" | translate }} 
              </button>
  
              <div class="text-center">
                <span class="fw-bold" *ngIf="introductionParamLabel">
                  {{ introductionParamLabel }}
                </span>
              </div>

              <button class="btn-sggs" color="primary" (click)="handleNext()">
                {{ "next" | translate }} &gt;
              </button>
            </div>
          </div> -->
          <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------------ -->

          <div style="display: none; align-items: center; gap: 10px; justify-content: center; width: 100%;">
            <!-- <button (click)="move(-1)" [disabled]="activeIndex === 0">◀</button> -->
            <button [ngClass]="!previous  ? 'invisible' : 'visible' " class="btn-sggs"
              (click)="handlePrevious(); move(-1)">
              &lt;&lt;
              <!-- {{ "previous" | translate }}  -->
            </button>

            <div #scrollContainer style="overflow: hidden; flex: 1;">
              <div #buttonRow style="display: flex; transition: transform 0.3s ease;">
                <button *ngFor="let btn of buttons; let i = index" (click)="NavigateByBtnTag(btn,i)"
                  [style.background]="i === activeIndex ? '#ad8d3f' : '#ccc'"
                  [style.color]="i === activeIndex ? '#fff' : '#000'"
                  style="margin: 3px; padding: 5px 10px; border: none; border-radius: 4px; min-width: fit-content;">
                  {{ btn }}
                </button>
              </div>
            </div>

            <!-- <button (click)="move(1)" [disabled]="activeIndex === buttons.length - 1">▶</button>
            <button class="nav-button" (click)="move(1)" [disabled]="isNextDisabled">Next</button> -->
            <button class="btn-sggs" color="primary" (click)="handleNext(); move(1)">
              <!-- {{ "next" | translate }}  -->
              &gt;&gt;
            </button>

          </div>
          <!-- -----------------------------------------------------------------------for demo manmeet mam------------------------------------------------------------------------------------- -->
          <div style="display: flex; align-items: center; gap: 10px; justify-content: center; width: 100%;">
            <div class="button-row-wrapper" [class.is-mobile]="isHandsetPortrait">
              <div class="prevAndNextBtnSecForMobile btn-for-mobile">
                <button [ngClass]="!previous  ? 'invisible' : 'visible' " class="btn-sggs"
                  (click)="handlePrevious(); move(-1)">
                  &lt;&lt;
                </button>
                <button class="btn-sggs" color="primary" (click)="handleNext(); move(1)">
                  &gt;&gt;
                </button>
              </div>
              <button [ngClass]="!previous  ? 'invisible' : 'visible' " class="btn-sggs btn-for-dekstop"
                (click)="handlePrevious(); move(-1)">
                &lt;&lt;
              </button>
              <div #scrollContainer style="overflow: hidden; flex: 1; display: inline-flex;">
                <div #buttonRow style="display: inline-flex; transition: transform 0.3s ease;">
                  <!-- <button *ngFor="let btn of buttons; let i = index" (click)="setActive(i)" -->
                  <button *ngFor="let btn of buttons; let i = index" (click)="NavigateByBtnTag(btn,i)"
                    [style.background]="i === activeIndex ? '#ad8d3f' : '#ccc'"
                    [style.color]="i === activeIndex ? '#fff' : '#000'"
                    style="margin: 3px; padding: 5px 10px; border: none; border-radius: 4px; min-width: 80px;">
                    {{ btn }}
                  </button>
                </div>
              </div>
              <button *ngIf="isButtonsLoaded" class="btn-sggs btn-for-dekstop" color="primary" (click)="handleNext(); move(1)">
                &gt;&gt;
              </button>
            </div>
          </div>



          <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------------ -->


          <!-- <div class="introduction-param-label-wrapper custom-lab-wrp"> -->

          <!-- <div class="introduction-param-label" vv>
              {{ introductionParamLabel }}
            </div> -->

          <!-- <div  *ngIf="baniInfo?.Introduction">
              <button
              (click)="goToIntroduction()"
              class="btn-sggs"
              >
                {{ "introduction" | translate }}
              </button>
          </div>
          
          <div  *ngIf="baniInfo?.HistoricalDimension">
            <button
              
              (click)="goToHistoricalDimension()"
              class="btn-sggs"
            >
            {{ "historical" | translate }}
            </button>
            </div>
          <div  *ngIf="baniInfo?.CulturalDimension">
            <button
              
              (click)="goToCulturalDimension()"
              class="btn-sggs"
            >
             {{ "Cultural_Dimension" | translate }}
            </button>
            </div>
          <div  *ngIf="baniInfo?.MusicalDimension">
            <button
              
              (click)="goToMusicalDimension()"
              class="btn-sggs"
            >
            {{ "musical" | translate }}
            </button>
            </div>
          <div   *ngIf="baniInfo?.SignificantTerms">
            <button
             
              (click)="goToSignificantTerms()"
              class="btn-sggs"
            >
              {{ "Significant_Terms" | translate }}
            </button>
            </div>
          </div> -->


          <div *ngIf="isBaniIntroductionParameterLoading" class="introduction-content c sub-section-content">
            <div *ngFor="let paragraph of [0, 1, 2, 4]" class="loading-paragraph animate"></div>
          </div>

          <div *ngIf="!isBaniIntroductionParameterLoading" class="introduction-content v sub-section-content"
            [innerHTML]="introductionParamData"></div>

          <div class="introduction-footer">
            <div class="footer-nav-buttons-wrapper" [style.justify-content]="previous ? 'space-between' : 'end'">
              <button *ngIf="previous" [ngClass]="!previous  ? 'disabled' : '' " class="btn-sggs"
                (click)="handlePrevious()">
                &lt; {{ "previous" | translate }}
                <!-- <img alt="Previous Button Image"  [ngClass]="!previous  ? 'disabled' : '' " src="/assets/images/prev.png">
                <img alt="Previous Button Image" [ngClass]="!previous  ? '' : 'disabled' "src="/assets/images/prev-g.png"> -->
              </button>

              <!-- [disabled]="!next" -->
              <button class="btn-sggs" color="primary" (click)="handleNext()">
                {{ "next" | translate }} &gt;
                <!-- <img alt="Next Button Image" [src]="fetchLanguage() === 'pa' ? '/assets/images/next-golden-pa.png' : '/assets/images/next-1.png'" [attr.width]="fetchLanguage() != 'pa' ? 'auto' : '70'"> -->
              </button>
            </div>
            <!-- removed till update to implement them dynamically doesnt come -->
            <!-- <div class="footer-nav-tags-wrapper">
              <div class="tags-label">Tags</div>

              <mat-chip-set
                class="example-chip"
                cdkDropListOrientation="horizontal"
              >
                <mat-chip class="tag-box"> Asa Ki Var </mat-chip>
                <mat-chip class="tag-box"> Bani Mahala 9</mat-chip>
                <mat-chip class="tag-box"> So Purakhu </mat-chip>
                <mat-chip class="tag-box"> Arti </mat-chip>
                <mat-chip class="tag-box"> Kuchaji </mat-chip>
              </mat-chip-set>
            </div> -->
          </div>
        </div>

      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>